import RestaurantSource from '../../data/restaurant-source';
import UrlParser from '../../routes/url-parser';
import LikeButtonInitiator from '../../utils/like-button-initiator';
import { createRestaurantDetailTemplate } from '../templates/template-creator';

const Detail = {
  async render() {
    return `
      <div id="restaurant" class="restaurant">
        <div class="loader"></div>
      </div>
      <div id="likeButtonContainer"></div>
    `;
  },

  async afterRender() {
    const url = UrlParser.parseActiveUrlWithoutCombiner();
    const restaurantContainer = document.querySelector('#restaurant');

    const loader = document.querySelector('.loader');
    if (loader) {
      loader.style.display = 'none';
    }

    const restaurant = await RestaurantSource.getRestaurantDetail(url.id).catch(
      (error) => {
        if (loader) {
          loader.style.display = 'none';
        }
        restaurantContainer.textContent = `Error: ${error.message}`;
        return null;
      }
    );
    restaurantContainer.innerHTML = createRestaurantDetailTemplate(restaurant);

    LikeButtonInitiator.init({
      likeButtonContainer: document.querySelector('#likeButtonContainer'),
      restaurant: {
        id: restaurant.id,
        name: restaurant.name,
        description: restaurant.description,
        city: restaurant.city,
        rating: restaurant.rating,
        pictureId: restaurant.pictureId,
      },
    });

    const reviewForm = document.querySelector('#reviewForm');
    reviewForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      const reviewData = {
        id: url.id,
        name: document.querySelector('#name').value,
        review: document.querySelector('#review').value,
      };
      await RestaurantSource.postReview(reviewData);
      reviewForm.reset();
      await this.afterRender();
    });
  },
};

export default Detail;
